var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKpiDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "KPI_Dashboard",
    "data-name": "KPI Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 340.494,
    viewBox: "0 0 350 340.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-18, .cls-19, .cls-21, .cls-61, .cls-62, .cls-63 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f4c750;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #5b3439;\n      }\n\n      .cls-5 {\n        fill: #75525b;\n      }\n\n      .cls-6 {\n        fill: #461d25;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: #9a797d;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-10 {\n        fill: #f0dbd0;\n      }\n\n      .cls-11 {\n        fill: #755259;\n      }\n\n      .cls-12 {\n        fill: #390614;\n      }\n\n      .cls-13 {\n        fill: #3d415b;\n      }\n\n      .cls-14 {\n        fill: #bca39d;\n      }\n\n      .cls-15 {\n        fill: #83869b;\n      }\n\n      .cls-16 {\n        fill: #b2a8c3;\n      }\n\n      .cls-17 {\n        fill: #fdf7ed;\n        stroke: #5b3439;\n      }\n\n      .cls-17, .cls-18, .cls-19 {\n        stroke-width: 0.2px;\n      }\n\n      .cls-18 {\n        stroke: #40c6c2;\n      }\n\n      .cls-18, .cls-19, .cls-21, .cls-61, .cls-62, .cls-63 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-19 {\n        stroke: #8d9ab2;\n      }\n\n      .cls-20 {\n        fill: #708dce;\n      }\n\n      .cls-21 {\n        stroke: #e5495b;\n      }\n\n      .cls-21, .cls-62, .cls-63 {\n        stroke-width: 0.7px;\n      }\n\n      .cls-22 {\n        fill: #ad8a9d;\n      }\n\n      .cls-23 {\n        fill: #5b4169;\n      }\n\n      .cls-24 {\n        fill: #886d93;\n      }\n\n      .cls-25 {\n        fill: #ae9bb9;\n      }\n\n      .cls-26 {\n        fill: #657651;\n      }\n\n      .cls-27 {\n        fill: #a84c46;\n      }\n\n      .cls-28 {\n        fill: #a9b974;\n      }\n\n      .cls-29 {\n        fill: #e8726b;\n      }\n\n      .cls-30 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-31 {\n        fill: #efc463;\n      }\n\n      .cls-32 {\n        fill: #f8eadc;\n      }\n\n      .cls-33 {\n        opacity: 0.75;\n      }\n\n      .cls-34 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-35 {\n        fill: #86626f;\n      }\n\n      .cls-36 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-37 {\n        fill: #85616f;\n      }\n\n      .cls-38 {\n        fill: #e0782b;\n      }\n\n      .cls-39 {\n        fill: #4f345b;\n      }\n\n      .cls-40 {\n        fill: #f8e9e1;\n      }\n\n      .cls-41 {\n        fill: #685275;\n      }\n\n      .cls-42 {\n        fill: #4a4d5a;\n      }\n\n      .cls-43 {\n        fill: #a58094;\n      }\n\n      .cls-44 {\n        opacity: 0.42;\n      }\n\n      .cls-45 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-46 {\n        fill: #d0a6c5;\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-48 {\n        fill: #fffaf2;\n      }\n\n      .cls-49 {\n        fill: #4a79a7;\n      }\n\n      .cls-50 {\n        fill: #ffebe0;\n      }\n\n      .cls-51 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-52 {\n        fill: #c35716;\n      }\n\n      .cls-53 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-54 {\n        fill: #e68238;\n      }\n\n      .cls-55 {\n        fill: #a34615;\n      }\n\n      .cls-56 {\n        fill: #527e75;\n      }\n\n      .cls-57 {\n        fill: #464265;\n      }\n\n      .cls-58 {\n        fill: #69b19d;\n      }\n\n      .cls-59 {\n        fill: #6b70a5;\n      }\n\n      .cls-60 {\n        clip-path: url(#clip-path-11);\n      }\n\n      .cls-62 {\n        stroke: #4bb497;\n      }\n\n      .cls-63 {\n        stroke: #e68238;\n      }\n\n      .cls-64 {\n        fill: #aac3a8;\n      }\n\n      .cls-65, .cls-66 {\n        stroke: none;\n      }\n\n      .cls-66 {\n        fill: #d0b0ac;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25212",
    "data-name": "Rectangle 25212",
    className: "cls-1",
    width: 350,
    height: 340.494
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#695d89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54356a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.094,
    x2: 0,
    y2: 0.899,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62669b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69616",
    "data-name": "Path 69616",
    className: "cls-2",
    d: "M1146.58,707.759a17.68,17.68,0,0,0,8.537-2.374c.282-.154.559-.307.841-.466.138-.082.282-.169.426-.251s.282-.169.42-.256c.282-.179.559-.359.841-.544a34.761,34.761,0,0,0,3.63-2.784l-4.891-14.361Z",
    transform: "translate(-1146.58 -686.722)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25200",
    "data-name": "Rectangle 25200",
    className: "cls-1",
    width: 31.514,
    height: 35.588
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25201",
    "data-name": "Rectangle 25201",
    className: "cls-1",
    width: 46.5,
    height: 44.309
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25202",
    "data-name": "Rectangle 25202",
    className: "cls-1",
    width: 52.317,
    height: 27.782
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.78,
    y1: -0.071,
    x2: 0.574,
    y2: 1.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84ae7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496faf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69645",
    "data-name": "Path 69645",
    className: "cls-1",
    d: "M1679.468,203.858a13.064,13.064,0,0,1,1.52,6.512c0,9.4-6.976,21.048-16.029,27.367l.323,6.568c11.55-1.879,27.575-18.389,27.575-31.4,0-4.448-6.3-14.276-8.309-16.784Z",
    transform: "translate(-1664.959 -196.124)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69646",
    "data-name": "Path 69646",
    className: "cls-1",
    d: "M1725.5,228.89a13.069,13.069,0,0,1,1.519,6.512c0,9.4-6.975,21.048-16.028,27.367l.323,6.569c12.624-8.5,22.433-24.687,22.433-37.7,0-4.448-1.155-7.978-3.168-10.486Z",
    transform: "translate(-1710.986 -221.156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25206",
    "data-name": "Rectangle 25206",
    className: "cls-1",
    width: 34.562,
    height: 39.019
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67262",
    "data-name": "Group 67262",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67239",
    "data-name": "Group 67239",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67238",
    "data-name": "Group 67238",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69407",
    "data-name": "Path 69407",
    className: "cls-4",
    d: "M639.078,1553.357v5.576a9.7,9.7,0,0,1-5.87-1.344l-75.321-45.436c-2.289-1.386-3.3-8.944-1.59-10.74.241.252,1.265,4.954,1.59,5.154l75.321,45.446a9.625,9.625,0,0,0,5.87,1.344",
    transform: "translate(-471.293 -1273.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69408",
    "data-name": "Path 69408",
    className: "cls-5",
    d: "M768.08,1123.322,652,1190.8a9.567,9.567,0,0,1-3.969,1.26v-5.576a9.622,9.622,0,0,1-5.87-1.344l-75.321-45.446a4.239,4.239,0,0,1-.851-.683,4.1,4.1,0,0,1,.914-.714l65.2-37.9,52.009-30.231a8.338,8.338,0,0,1,8.516.073l75.52,45.552a4.113,4.113,0,0,1,1.1.966,4.363,4.363,0,0,1-1.166,6.563",
    transform: "translate(-480.241 -907.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69409",
    "data-name": "Path 69409",
    className: "cls-4",
    d: "M610.129,281.359V383.807a7.624,7.624,0,0,1-3.8,6.595L483.849,461.385c-.409.231.39,2.825-.03,2.9-2.468.525-6.207-3.771-6.207-6.49V356.3a10.893,10.893,0,0,1,1.092-4.788l5.145,3.16a10.984,10.984,0,0,1,4.253-4.431l119.843-69.461a4.6,4.6,0,0,1,2.027-.63,4.536,4.536,0,0,1,.157,1.208",
    transform: "translate(-405.255 -237.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69410",
    "data-name": "Path 69410",
    className: "cls-6",
    d: "M642.835,284.8V387.256a7.625,7.625,0,0,1-3.8,6.595L516.555,464.824a4.15,4.15,0,0,1-6.2-3.066,4.244,4.244,0,0,1-.031-.525v-92.3c0-1.827.451-12.787,1.281-14.352a10.984,10.984,0,0,1,4.253-4.431L635.7,280.691a4.736,4.736,0,0,1,4.169-.294l.032.011a4.713,4.713,0,0,1,1.869,1.4l.011.011a4.659,4.659,0,0,1,1.05,2.982",
    transform: "translate(-433.015 -237.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69411",
    "data-name": "Path 69411",
    className: "cls-7",
    d: "M663.358,309.8V412.259A3.18,3.18,0,0,1,661.785,415l-122,70.693.006-82.254v-9.492c0-1.078.263-11.323.76-12.266a6.568,6.568,0,0,1,2.547-2.658l119.842-69.462h.049l.11-.043.165.067.08.092a.263.263,0,0,1,.018.129",
    transform: "translate(-458.006 -262.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69412",
    "data-name": "Path 69412",
    className: "cls-8",
    d: "M618.231,260.576a4.735,4.735,0,0,0-4.168.294L494.219,330.332a10.984,10.984,0,0,0-4.253,4.431l-5.145-3.16a11.025,11.025,0,0,1,4.442-4.809l7.361-4.263,112.493-65.2a4.7,4.7,0,0,1,5.492.535l.032.021Z",
    transform: "translate(-411.373 -217.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69413",
    "data-name": "Path 69413",
    className: "cls-9",
    d: "M663.392,309.8v17.084L539.821,398.5v-4.561c0-1.078.263-11.323.76-12.266a6.564,6.564,0,0,1,2.547-2.658L662.97,309.558h.049l.11-.043.165.067.08.092a.263.263,0,0,1,.018.129",
    transform: "translate(-458.04 -262.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69414",
    "data-name": "Path 69414",
    className: "cls-10",
    d: "M763.056,1085.523a4.308,4.308,0,0,1-1.166.987l-116.084,67.466a9.74,9.74,0,0,1-3.969,1.271,9.623,9.623,0,0,1-5.87-1.344l-75.321-45.446a4.249,4.249,0,0,1-.851-.682,4.054,4.054,0,0,1,.914-6.29l55.6-32.32,61.607-35.807a8.362,8.362,0,0,1,8.516.063l75.52,45.562a4.372,4.372,0,0,1,1.1,6.542",
    transform: "translate(-474.051 -875.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69415",
    "data-name": "Path 69415",
    className: "cls-11",
    d: "M845.646,1121.772l-95.456,55.674a5.055,5.055,0,0,1-5.152-.042l-39.472-23.812a2.126,2.126,0,0,1,.03-3.658l96.043-56.016a4.381,4.381,0,0,1,4.465.037l39.574,23.874a2.292,2.292,0,0,1-.032,3.944",
    transform: "translate(-597.804 -927.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69416",
    "data-name": "Path 69416",
    className: "cls-12",
    d: "M823.612,1426.365l-3.224-1.951a.36.36,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32",
    transform: "translate(-692.769 -1208.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69417",
    "data-name": "Path 69417",
    className: "cls-12",
    d: "M856.666,1407.078a.414.414,0,0,0,.42.005l3.43-1.986a.184.184,0,0,0,0-.319l-3.225-1.952a.36.36,0,0,0-.364-.005l-3.478,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-724.085 -1190.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69418",
    "data-name": "Path 69418",
    className: "cls-12",
    d: "M893.573,1385.493a.414.414,0,0,0,.42.006l3.43-1.986a.185.185,0,0,0,0-.319l-3.224-1.951a.357.357,0,0,0-.364-.005l-3.479,2.013a.171.171,0,0,0,0,.3Z",
    transform: "translate(-755.4 -1171.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69419",
    "data-name": "Path 69419",
    className: "cls-12",
    d: "M930.48,1363.908a.414.414,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0l-3.479,2.012a.172.172,0,0,0,0,.3Z",
    transform: "translate(-786.716 -1153.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69420",
    "data-name": "Path 69420",
    className: "cls-12",
    d: "M967.387,1342.322a.412.412,0,0,0,.419.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-818.031 -1135.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69421",
    "data-name": "Path 69421",
    className: "cls-12",
    d: "M1004.293,1320.738a.414.414,0,0,0,.419.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-849.346 -1117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69422",
    "data-name": "Path 69422",
    className: "cls-12",
    d: "M1041.2,1299.152a.414.414,0,0,0,.42.006l3.43-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-880.662 -1098.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69423",
    "data-name": "Path 69423",
    className: "cls-12",
    d: "M1078.107,1277.566a.413.413,0,0,0,.42.006l3.43-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0l-3.479,2.012a.172.172,0,0,0,0,.3Z",
    transform: "translate(-911.978 -1080.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69424",
    "data-name": "Path 69424",
    className: "cls-12",
    d: "M1115.013,1255.981a.414.414,0,0,0,.42.005l3.43-1.985a.185.185,0,0,0,0-.319l-3.224-1.951a.359.359,0,0,0-.364-.005l-3.478,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-943.293 -1062.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69425",
    "data-name": "Path 69425",
    className: "cls-12",
    d: "M1151.921,1234.4a.415.415,0,0,0,.42.005l3.431-1.986a.185.185,0,0,0,0-.319l-3.224-1.951a.359.359,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-974.609 -1043.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69426",
    "data-name": "Path 69426",
    className: "cls-13",
    d: "M1188.828,1212.81a.414.414,0,0,0,.419.006l3.43-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364-.005l-3.478,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-1005.925 -1025.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69427",
    "data-name": "Path 69427",
    className: "cls-13",
    d: "M1225.735,1191.224a.414.414,0,0,0,.419.006l3.431-1.986a.185.185,0,0,0,0-.319l-3.225-1.951a.357.357,0,0,0-.364-.005l-3.479,2.013a.171.171,0,0,0,0,.3Z",
    transform: "translate(-1037.241 -1007.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69428",
    "data-name": "Path 69428",
    className: "cls-13",
    d: "M1262.642,1169.64a.414.414,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.32l-3.225-1.951a.358.358,0,0,0-.363-.005l-3.479,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-1068.557 -988.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69429",
    "data-name": "Path 69429",
    className: "cls-13",
    d: "M1299.549,1148.054a.415.415,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.952a.358.358,0,0,0-.364,0l-3.478,2.012a.172.172,0,0,0,0,.3Z",
    transform: "translate(-1099.872 -970.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69430",
    "data-name": "Path 69430",
    className: "cls-12",
    d: "M865.971,1451.88l-3.224-1.951a.359.359,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.32",
    transform: "translate(-728.71 -1230.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69431",
    "data-name": "Path 69431",
    className: "cls-12",
    d: "M899.289,1428.337l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.416.416,0,0,0,.42.005l3.431-1.986a.185.185,0,0,0,0-.319l-3.224-1.951a.359.359,0,0,0-.364-.005",
    transform: "translate(-760.026 -1211.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69432",
    "data-name": "Path 69432",
    className: "cls-12",
    d: "M936.351,1411.015l3.431-1.986a.185.185,0,0,0,0-.32l-3.225-1.951a.362.362,0,0,0-.364-.005l-3.478,2.013a.171.171,0,0,0,0,.3l3.216,1.947a.417.417,0,0,0,.42.006",
    transform: "translate(-791.341 -1193.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69433",
    "data-name": "Path 69433",
    className: "cls-12",
    d: "M973.1,1385.168l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.413.413,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.357.357,0,0,0-.364,0",
    transform: "translate(-822.657 -1175.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69434",
    "data-name": "Path 69434",
    className: "cls-12",
    d: "M1010.01,1363.583l-3.478,2.012a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364,0",
    transform: "translate(-853.972 -1156.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69435",
    "data-name": "Path 69435",
    className: "cls-12",
    d: "M1046.917,1342l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.952a.362.362,0,0,0-.364,0",
    transform: "translate(-885.289 -1138.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69436",
    "data-name": "Path 69436",
    className: "cls-12",
    d: "M1083.824,1320.413l-3.478,2.012a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.952a.36.36,0,0,0-.364,0",
    transform: "translate(-916.604 -1120.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69437",
    "data-name": "Path 69437",
    className: "cls-12",
    d: "M1120.731,1298.826l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006l3.43-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0",
    transform: "translate(-947.92 -1102.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69438",
    "data-name": "Path 69438",
    className: "cls-12",
    d: "M1157.637,1277.241l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.419.006l3.43-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.36.36,0,0,0-.365-.005",
    transform: "translate(-979.235 -1083.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69439",
    "data-name": "Path 69439",
    className: "cls-13",
    d: "M1194.544,1255.655l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.416.416,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364-.005",
    transform: "translate(-1010.551 -1065.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69440",
    "data-name": "Path 69440",
    className: "cls-13",
    d: "M1231.451,1234.07l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.416.416,0,0,0,.42.005l3.431-1.986a.185.185,0,0,0,0-.319l-3.225-1.951a.359.359,0,0,0-.363-.005",
    transform: "translate(-1041.866 -1047.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69441",
    "data-name": "Path 69441",
    className: "cls-13",
    d: "M1268.359,1212.486l-3.479,2.012a.172.172,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.419.005l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364,0",
    transform: "translate(-1073.182 -1028.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69442",
    "data-name": "Path 69442",
    className: "cls-13",
    d: "M1308.853,1192.856l-3.224-1.951a.358.358,0,0,0-.364,0l-3.478,2.012a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.005l3.431-1.985a.186.186,0,0,0,0-.32",
    transform: "translate(-1104.497 -1010.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69443",
    "data-name": "Path 69443",
    className: "cls-13",
    d: "M1338.691,1171.625l3.216,1.946a.415.415,0,0,0,.42.006l3.43-1.985a.185.185,0,0,0,0-.32l-3.224-1.952a.358.358,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3",
    transform: "translate(-1135.813 -992.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69444",
    "data-name": "Path 69444",
    className: "cls-12",
    d: "M913.918,1456.131a.186.186,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364,0l-1.314.76c-.007,0-.016,0-.023.006l-1.361.795-.78.451s0,.005,0,.005l-5.59,3.265a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.006l6.3-3.682Z",
    transform: "translate(-764.652 -1233.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69445",
    "data-name": "Path 69445",
    className: "cls-12",
    d: "M978.289,1436.524a.415.415,0,0,0,.42.005l3.43-1.985a.186.186,0,0,0,0-.32l-3.224-1.951a.357.357,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-827.282 -1215.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69446",
    "data-name": "Path 69446",
    className: "cls-12",
    d: "M1015.462,1410.684l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.412.412,0,0,0,.42.005l3.43-1.984a.185.185,0,0,0,0-.32l-3.224-1.952a.359.359,0,0,0-.364,0",
    transform: "translate(-858.599 -1196.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69447",
    "data-name": "Path 69447",
    className: "cls-12",
    d: "M1052.368,1389.1l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.945a.412.412,0,0,0,.419.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.361.361,0,0,0-.364-.005",
    transform: "translate(-889.914 -1178.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69448",
    "data-name": "Path 69448",
    className: "cls-12",
    d: "M1089.275,1367.513l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0",
    transform: "translate(-921.23 -1160.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69449",
    "data-name": "Path 69449",
    className: "cls-12",
    d: "M1126.182,1345.928l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.42,0l3.43-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364-.005",
    transform: "translate(-952.546 -1141.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69450",
    "data-name": "Path 69450",
    className: "cls-12",
    d: "M1163.089,1324.341l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.416.416,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364-.005",
    transform: "translate(-983.861 -1123.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69451",
    "data-name": "Path 69451",
    className: "cls-13",
    d: "M1200,1302.757l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.357.357,0,0,0-.364-.005",
    transform: "translate(-1015.176 -1105.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69452",
    "data-name": "Path 69452",
    className: "cls-13",
    d: "M1236.9,1281.171l-3.478,2.013a.171.171,0,0,0,0,.3l3.216,1.947a.412.412,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.356.356,0,0,0-.364-.005",
    transform: "translate(-1046.493 -1087.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69453",
    "data-name": "Path 69453",
    className: "cls-13",
    d: "M1273.965,1263.847l3.431-1.986a.185.185,0,0,0,0-.319l-3.224-1.951a.36.36,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.419.005",
    transform: "translate(-1077.808 -1068.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69454",
    "data-name": "Path 69454",
    className: "cls-13",
    d: "M1311.08,1238.006a.358.358,0,0,0-.364-.005l-3.479,2.013a.171.171,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.32Z",
    transform: "translate(-1109.123 -1050.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69455",
    "data-name": "Path 69455",
    className: "cls-13",
    d: "M1347.623,1198.1l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.42.006l1.2-.7a.392.392,0,0,0,.053-.014l7.768-4.547a.185.185,0,0,0,0-.319l-3.224-1.951a.359.359,0,0,0-.364-.005l-5.585,3.268Z",
    transform: "translate(-1140.439 -1013.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69456",
    "data-name": "Path 69456",
    className: "cls-12",
    d: "M950.688,1502.91l-3.224-1.951a.358.358,0,0,0-.364-.005l-3.479,2.013a.171.171,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.32",
    transform: "translate(-800.593 -1273.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69457",
    "data-name": "Path 69457",
    className: "cls-12",
    d: "M980.525,1481.679l3.216,1.946a.414.414,0,0,0,.42.006l3.431-1.985a.185.185,0,0,0,0-.319l-3.224-1.952a.359.359,0,0,0-.364,0l-3.479,2.013a.171.171,0,0,0,0,.3",
    transform: "translate(-831.908 -1255.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69458",
    "data-name": "Path 69458",
    className: "cls-12",
    d: "M1017.432,1460.094l3.216,1.945a.414.414,0,0,0,.42.006l3.43-1.985a.185.185,0,0,0,0-.32l-3.224-1.952a.359.359,0,0,0-.364,0l-3.479,2.012a.172.172,0,0,0,0,.3",
    transform: "translate(-863.224 -1236.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69459",
    "data-name": "Path 69459",
    className: "cls-12",
    d: "M1057.975,1440.46l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.36.36,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006",
    transform: "translate(-894.54 -1218.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69460",
    "data-name": "Path 69460",
    className: "cls-12",
    d: "M1094.882,1418.875l3.43-1.985a.185.185,0,0,0,0-.32l-3.225-1.951a.358.358,0,0,0-.364,0l-3.478,2.013a.171.171,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006",
    transform: "translate(-925.855 -1200.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69461",
    "data-name": "Path 69461",
    className: "cls-12",
    d: "M1131.788,1397.29l3.43-1.986a.185.185,0,0,0,0-.319l-3.225-1.952a.358.358,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006",
    transform: "translate(-957.17 -1181.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69462",
    "data-name": "Path 69462",
    className: "cls-12",
    d: "M1168.7,1375.7l3.43-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.358.358,0,0,0-.364-.005l-3.478,2.013a.171.171,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.42.006",
    transform: "translate(-988.486 -1163.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69463",
    "data-name": "Path 69463",
    className: "cls-13",
    d: "M1205.6,1354.118l3.431-1.986a.185.185,0,0,0,0-.319l-3.225-1.951a.357.357,0,0,0-.363-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.416.416,0,0,0,.42.006",
    transform: "translate(-1019.802 -1145.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69464",
    "data-name": "Path 69464",
    className: "cls-13",
    d: "M1242.509,1332.534l3.43-1.986a.185.185,0,0,0,0-.319l-3.225-1.951a.358.358,0,0,0-.364-.005l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.42.006",
    transform: "translate(-1051.118 -1127.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69465",
    "data-name": "Path 69465",
    className: "cls-13",
    d: "M1279.416,1310.948l3.431-1.985a.186.186,0,0,0,0-.32l-3.225-1.951a.358.358,0,0,0-.363,0l-3.479,2.012a.171.171,0,0,0,0,.3l3.215,1.947a.416.416,0,0,0,.42.006",
    transform: "translate(-1082.434 -1108.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69466",
    "data-name": "Path 69466",
    className: "cls-13",
    d: "M1316.323,1289.362l3.431-1.985a.185.185,0,0,0,0-.32l-3.225-1.951a.356.356,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3l3.215,1.946a.415.415,0,0,0,.42.005",
    transform: "translate(-1113.75 -1090.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69467",
    "data-name": "Path 69467",
    className: "cls-13",
    d: "M1353.076,1263.517l-3.479,2.013a.171.171,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.319l-3.225-1.952a.359.359,0,0,0-.363,0",
    transform: "translate(-1145.065 -1072.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69468",
    "data-name": "Path 69468",
    className: "cls-13",
    d: "M1390.138,1246.192l3.43-1.985a.185.185,0,0,0,0-.32l-3.225-1.951a.358.358,0,0,0-.364,0l-3.478,2.013a.171.171,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.42.005",
    transform: "translate(-1176.381 -1053.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69469",
    "data-name": "Path 69469",
    className: "cls-13",
    d: "M1423.408,1222.655l3.216,1.946a.415.415,0,0,0,.42.006l3.43-1.985a.185.185,0,0,0,0-.319l-3.224-1.951a.358.358,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3",
    transform: "translate(-1207.697 -1035.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69470",
    "data-name": "Path 69470",
    className: "cls-12",
    d: "M993.046,1528.426l-3.225-1.951a.36.36,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006l3.431-1.985a.186.186,0,0,0,0-.32",
    transform: "translate(-836.534 -1295.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69471",
    "data-name": "Path 69471",
    className: "cls-12",
    d: "M1026.1,1509.141a.415.415,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3Z",
    transform: "translate(-867.85 -1276.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69472",
    "data-name": "Path 69472",
    className: "cls-12",
    d: "M1063.427,1487.561l3.431-1.986a.185.185,0,0,0,0-.319l-3.225-1.952a.36.36,0,0,0-.364,0l-3.479,2.013a.171.171,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006",
    transform: "translate(-899.166 -1258.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69473",
    "data-name": "Path 69473",
    className: "cls-12",
    d: "M1100.333,1465.975l3.43-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.36.36,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.006",
    transform: "translate(-930.481 -1240.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69474",
    "data-name": "Path 69474",
    className: "cls-12",
    d: "M1137.24,1444.39l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.357.357,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.411.411,0,0,0,.42.005",
    transform: "translate(-961.797 -1221.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69475",
    "data-name": "Path 69475",
    className: "cls-12",
    d: "M1174.147,1422.805l3.431-1.986a.185.185,0,0,0,0-.319l-3.225-1.951a.358.358,0,0,0-.363-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.419.006",
    transform: "translate(-993.112 -1203.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69476",
    "data-name": "Path 69476",
    className: "cls-13",
    d: "M1211.054,1401.219l3.431-1.986a.185.185,0,0,0,0-.32l-3.225-1.951a.358.358,0,0,0-.364-.005l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.414.414,0,0,0,.419.005",
    transform: "translate(-1024.428 -1185.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69477",
    "data-name": "Path 69477",
    className: "cls-13",
    d: "M1247.961,1379.633l3.431-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.947a.415.415,0,0,0,.419.005",
    transform: "translate(-1055.744 -1166.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69478",
    "data-name": "Path 69478",
    className: "cls-13",
    d: "M1284.868,1358.049l3.431-1.986a.185.185,0,0,0,0-.32l-3.224-1.951a.361.361,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.416.416,0,0,0,.42.006",
    transform: "translate(-1087.059 -1148.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69479",
    "data-name": "Path 69479",
    className: "cls-13",
    d: "M1321.775,1336.463l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.952a.357.357,0,0,0-.364,0l-3.479,2.012a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.005",
    transform: "translate(-1118.375 -1130.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69480",
    "data-name": "Path 69480",
    className: "cls-13",
    d: "M1358.681,1314.877l3.43-1.986a.185.185,0,0,0,0-.319l-3.225-1.951a.357.357,0,0,0-.364,0l-3.478,2.012a.172.172,0,0,0,0,.3l3.216,1.946a.416.416,0,0,0,.42.006",
    transform: "translate(-1149.69 -1112.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69481",
    "data-name": "Path 69481",
    className: "cls-13",
    d: "M1395.588,1293.292l3.431-1.985a.185.185,0,0,0,0-.319l-3.224-1.952a.36.36,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.005",
    transform: "translate(-1181.005 -1093.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69482",
    "data-name": "Path 69482",
    className: "cls-13",
    d: "M1432.495,1271.707l3.431-1.985a.185.185,0,0,0,0-.32l-3.224-1.951a.359.359,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.005",
    transform: "translate(-1212.321 -1075.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69483",
    "data-name": "Path 69483",
    className: "cls-13",
    d: "M1465.766,1248.17l3.216,1.945a.414.414,0,0,0,.419.006l3.431-1.986a.185.185,0,0,0,0-.319l-3.224-1.952a.359.359,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3",
    transform: "translate(-1243.637 -1057.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69484",
    "data-name": "Path 69484",
    className: "cls-12",
    d: "M1032.18,1551.989a.358.358,0,0,0-.364,0l-3.479,2.013a.173.173,0,0,0,0,.3l3.216,1.945a.412.412,0,0,0,.419.006l3.431-1.985a.185.185,0,0,0,0-.32Z",
    transform: "translate(-872.475 -1316.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69485",
    "data-name": "Path 69485",
    className: "cls-12",
    d: "M1069.087,1530.406a.359.359,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.42.005l3.43-1.985a.185.185,0,0,0,0-.32Z",
    transform: "translate(-903.791 -1298.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69486",
    "data-name": "Path 69486",
    className: "cls-12",
    d: "M1105.994,1508.82a.36.36,0,0,0-.364,0l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.005l3.43-1.985a.185.185,0,0,0,0-.319Z",
    transform: "translate(-935.106 -1280.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69487",
    "data-name": "Path 69487",
    className: "cls-12",
    d: "M1142.9,1487.234a.36.36,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.419.006l3.431-1.986a.185.185,0,0,0,0-.32Z",
    transform: "translate(-966.422 -1261.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69488",
    "data-name": "Path 69488",
    className: "cls-12",
    d: "M1202.172,1379.308a.357.357,0,0,0-.364,0l-1.7.982a.348.348,0,0,0-.216.038l-23.931,14.073a.172.172,0,0,0,0,.3l3.216,1.947a.415.415,0,0,0,.419.006l5.536-3.256a.383.383,0,0,0,.055-.014l3.43-1.986c.03-.017.03-.05.045-.077l2.005-1.179a.4.4,0,0,0,.11-.028l3.431-1.986c.04-.023.047-.066.061-.1l1.934-1.138a.408.408,0,0,0,.166-.042l3.431-1.986a.174.174,0,0,0,.078-.133l1.868-1.1a.418.418,0,0,0,.215-.053l3.431-1.985a.186.186,0,0,0,0-.32Z",
    transform: "translate(-997.737 -1170.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69489",
    "data-name": "Path 69489",
    className: "cls-13",
    d: "M1364.342,1357.723a.36.36,0,0,0-.364,0l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.319Z",
    transform: "translate(-1154.316 -1151.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69490",
    "data-name": "Path 69490",
    className: "cls-13",
    d: "M1401.249,1336.137a.359.359,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.413.413,0,0,0,.42.005l3.431-1.985a.185.185,0,0,0,0-.319Z",
    transform: "translate(-1185.632 -1133.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69491",
    "data-name": "Path 69491",
    className: "cls-13",
    d: "M1438.155,1314.552a.36.36,0,0,0-.364-.005l-3.479,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.415.415,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.32Z",
    transform: "translate(-1216.947 -1115.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69492",
    "data-name": "Path 69492",
    className: "cls-13",
    d: "M1475.062,1292.966a.36.36,0,0,0-.364-.005l-3.478,2.013a.172.172,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.005l3.43-1.985a.185.185,0,0,0,0-.32Z",
    transform: "translate(-1248.262 -1097.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69493",
    "data-name": "Path 69493",
    className: "cls-13",
    d: "M1515.194,1273.332l-3.224-1.951a.359.359,0,0,0-.364-.005l-3.479,2.013a.171.171,0,0,0,0,.3l3.216,1.946a.414.414,0,0,0,.42.006l3.431-1.986a.185.185,0,0,0,0-.319",
    transform: "translate(-1279.579 -1078.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69494",
    "data-name": "Path 69494",
    className: "cls-14",
    d: "M823.609,1422.261l-3.431,1.985a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.363.005l3.225,1.952a.185.185,0,0,1,0,.319",
    transform: "translate(-692.769 -1204.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69495",
    "data-name": "Path 69495",
    className: "cls-14",
    d: "M860.516,1400.675l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-724.085 -1186.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69496",
    "data-name": "Path 69496",
    className: "cls-14",
    d: "M897.423,1379.09l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-755.4 -1168.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69497",
    "data-name": "Path 69497",
    className: "cls-14",
    d: "M934.331,1357.5l-3.431,1.985a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-786.716 -1149.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69498",
    "data-name": "Path 69498",
    className: "cls-14",
    d: "M971.237,1335.919l-3.43,1.985a.414.414,0,0,1-.42-.005l-3.216-1.946a.171.171,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-818.032 -1131.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69499",
    "data-name": "Path 69499",
    className: "cls-14",
    d: "M1008.144,1314.335l-3.43,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-849.348 -1113.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69500",
    "data-name": "Path 69500",
    className: "cls-14",
    d: "M1045.051,1292.749l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-880.662 -1094.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69501",
    "data-name": "Path 69501",
    className: "cls-14",
    d: "M1081.957,1271.163l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.013a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-911.978 -1076.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69502",
    "data-name": "Path 69502",
    className: "cls-14",
    d: "M1118.864,1249.578l-3.431,1.986a.413.413,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.013a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-943.294 -1058.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69503",
    "data-name": "Path 69503",
    className: "cls-14",
    d: "M1155.771,1227.992l-3.431,1.985a.413.413,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-974.609 -1039.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69504",
    "data-name": "Path 69504",
    className: "cls-15",
    d: "M1192.678,1206.407l-3.43,1.985a.416.416,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.012a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1005.926 -1021.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69505",
    "data-name": "Path 69505",
    className: "cls-15",
    d: "M1229.585,1184.822l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.363,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1037.24 -1003.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69506",
    "data-name": "Path 69506",
    className: "cls-15",
    d: "M1266.493,1163.237l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.947a.171.171,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1068.557 -985.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69507",
    "data-name": "Path 69507",
    className: "cls-15",
    d: "M1303.4,1141.651l-3.431,1.985a.413.413,0,0,1-.419-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.36.36,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1099.872 -966.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69508",
    "data-name": "Path 69508",
    className: "cls-14",
    d: "M865.968,1447.776l-3.431,1.985a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-728.711 -1226.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69509",
    "data-name": "Path 69509",
    className: "cls-14",
    d: "M902.876,1426.191l-3.431,1.985a.413.413,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.013a.356.356,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-760.026 -1208.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69510",
    "data-name": "Path 69510",
    className: "cls-14",
    d: "M939.783,1404.6l-3.431,1.985a.413.413,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.357.357,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-791.342 -1189.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69511",
    "data-name": "Path 69511",
    className: "cls-14",
    d: "M976.688,1383.02l-3.431,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-822.657 -1171.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69512",
    "data-name": "Path 69512",
    className: "cls-14",
    d: "M1013.6,1361.434l-3.431,1.986a.415.415,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-853.973 -1153.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69513",
    "data-name": "Path 69513",
    className: "cls-14",
    d: "M1050.5,1339.849l-3.43,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.952a.185.185,0,0,1,0,.32",
    transform: "translate(-885.288 -1134.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69514",
    "data-name": "Path 69514",
    className: "cls-14",
    d: "M1087.409,1318.264l-3.43,1.985a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-916.604 -1116.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69515",
    "data-name": "Path 69515",
    className: "cls-14",
    d: "M1124.316,1296.678l-3.43,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.362.362,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-947.92 -1098.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69516",
    "data-name": "Path 69516",
    className: "cls-14",
    d: "M1161.223,1275.093l-3.43,1.986a.416.416,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.012a.358.358,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-979.235 -1079.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69517",
    "data-name": "Path 69517",
    className: "cls-15",
    d: "M1198.13,1253.509l-3.431,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1010.551 -1061.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69518",
    "data-name": "Path 69518",
    className: "cls-15",
    d: "M1235.037,1231.922l-3.43,1.985a.414.414,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1041.867 -1043.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69519",
    "data-name": "Path 69519",
    className: "cls-15",
    d: "M1271.943,1210.338l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1073.182 -1025.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69520",
    "data-name": "Path 69520",
    className: "cls-15",
    d: "M1308.85,1188.752l-3.431,1.986a.414.414,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1104.497 -1006.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69521",
    "data-name": "Path 69521",
    className: "cls-15",
    d: "M1345.758,1167.166l-3.43,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.952a.185.185,0,0,1,0,.32",
    transform: "translate(-1135.813 -988.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69522",
    "data-name": "Path 69522",
    className: "cls-14",
    d: "M912.58,1456.767l-7.684,4.489a.414.414,0,0,1-.42-.005l-3.216-1.946a.171.171,0,0,1,0-.3l7.732-4.516a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-764.651 -1234.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69523",
    "data-name": "Path 69523",
    className: "cls-14",
    d: "M945.233,1451.706l-3.431,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.012a.361.361,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-795.967 -1229.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69524",
    "data-name": "Path 69524",
    className: "cls-14",
    d: "M982.14,1430.122l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.012a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-827.283 -1211.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69525",
    "data-name": "Path 69525",
    className: "cls-14",
    d: "M1019.047,1408.535l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-858.599 -1193.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69526",
    "data-name": "Path 69526",
    className: "cls-14",
    d: "M1055.954,1386.95l-3.431,1.985a.412.412,0,0,1-.42-.005l-3.216-1.947a.171.171,0,0,1,0-.3l3.479-2.013a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-889.914 -1174.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69527",
    "data-name": "Path 69527",
    className: "cls-14",
    d: "M1092.861,1365.365l-3.43,1.985a.414.414,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-921.23 -1156.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69528",
    "data-name": "Path 69528",
    className: "cls-14",
    d: "M1129.768,1343.779l-3.431,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.012a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-952.546 -1138.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69529",
    "data-name": "Path 69529",
    className: "cls-14",
    d: "M1166.675,1322.195l-3.43,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.012a.36.36,0,0,1,.364,0l3.224,1.952a.185.185,0,0,1,0,.319",
    transform: "translate(-983.861 -1119.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69530",
    "data-name": "Path 69530",
    className: "cls-15",
    d: "M1203.581,1300.608l-3.431,1.985a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-1015.176 -1101.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69531",
    "data-name": "Path 69531",
    className: "cls-15",
    d: "M1240.488,1279.024l-3.431,1.985a.415.415,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1046.492 -1083.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69532",
    "data-name": "Path 69532",
    className: "cls-15",
    d: "M1277.4,1257.438l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.36.36,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1077.808 -1064.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69533",
    "data-name": "Path 69533",
    className: "cls-15",
    d: "M1314.3,1235.853l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1109.123 -1046.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69534",
    "data-name": "Path 69534",
    className: "cls-15",
    d: "M1351.209,1214.267l-3.431,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1140.439 -1028.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69535",
    "data-name": "Path 69535",
    className: "cls-15",
    d: "M1363.824,1192.682l-7.768,4.546a.412.412,0,0,1-.419-.006l-3.216-1.946a.172.172,0,0,1,0-.3l7.816-4.574a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1147.463 -1010.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69536",
    "data-name": "Path 69536",
    className: "cls-14",
    d: "M950.686,1498.807l-3.431,1.985a.414.414,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-800.593 -1269.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69537",
    "data-name": "Path 69537",
    className: "cls-14",
    d: "M987.593,1477.221l-3.431,1.986a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.356.356,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-831.909 -1251.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69538",
    "data-name": "Path 69538",
    className: "cls-14",
    d: "M1024.5,1455.636l-3.431,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-863.224 -1233.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69539",
    "data-name": "Path 69539",
    className: "cls-14",
    d: "M1061.405,1434.051l-3.43,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-894.539 -1214.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69540",
    "data-name": "Path 69540",
    className: "cls-14",
    d: "M1098.312,1412.465l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-925.855 -1196.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69541",
    "data-name": "Path 69541",
    className: "cls-14",
    d: "M1135.219,1390.88l-3.431,1.986a.413.413,0,0,1-.419-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-957.171 -1178.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69542",
    "data-name": "Path 69542",
    className: "cls-14",
    d: "M1172.126,1369.3l-3.43,1.985a.413.413,0,0,1-.42-.005l-3.216-1.947a.171.171,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-988.487 -1159.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69543",
    "data-name": "Path 69543",
    className: "cls-15",
    d: "M1209.034,1347.709l-3.431,1.985a.413.413,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.013a.355.355,0,0,1,.363.005l3.225,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-1019.803 -1141.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69544",
    "data-name": "Path 69544",
    className: "cls-15",
    d: "M1245.94,1326.124l-3.431,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1051.118 -1123.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69545",
    "data-name": "Path 69545",
    className: "cls-15",
    d: "M1282.848,1304.539l-3.431,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1082.434 -1104.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69546",
    "data-name": "Path 69546",
    className: "cls-15",
    d: "M1319.754,1282.953l-3.431,1.986a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364.005l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1113.749 -1086.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69547",
    "data-name": "Path 69547",
    className: "cls-15",
    d: "M1356.66,1261.368l-3.43,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.362.362,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1145.065 -1068.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69548",
    "data-name": "Path 69548",
    className: "cls-15",
    d: "M1393.567,1239.784l-3.431,1.985a.412.412,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1176.38 -1049.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69549",
    "data-name": "Path 69549",
    className: "cls-15",
    d: "M1430.475,1218.2l-3.431,1.985a.413.413,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.013a.356.356,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-1207.696 -1031.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69550",
    "data-name": "Path 69550",
    className: "cls-14",
    d: "M993.044,1524.323l-3.43,1.985a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-836.535 -1291.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69551",
    "data-name": "Path 69551",
    className: "cls-14",
    d: "M1029.95,1502.737l-3.43,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-867.85 -1273.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69552",
    "data-name": "Path 69552",
    className: "cls-14",
    d: "M1066.857,1481.151l-3.43,1.986a.416.416,0,0,1-.42-.005l-3.216-1.946a.171.171,0,0,1,0-.3l3.478-2.013a.358.358,0,0,1,.364,0l3.224,1.95a.185.185,0,0,1,0,.32",
    transform: "translate(-899.165 -1254.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69553",
    "data-name": "Path 69553",
    className: "cls-14",
    d: "M1103.765,1459.565l-3.431,1.986a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.186.186,0,0,1,0,.32",
    transform: "translate(-930.481 -1236.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69554",
    "data-name": "Path 69554",
    className: "cls-14",
    d: "M1140.671,1437.981l-3.43,1.986a.413.413,0,0,1-.42-.006l-3.216-1.946a.171.171,0,0,1,0-.3l3.478-2.013a.358.358,0,0,1,.364.005l3.225,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-961.797 -1218.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69555",
    "data-name": "Path 69555",
    className: "cls-14",
    d: "M1177.578,1416.395l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-993.112 -1199.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69556",
    "data-name": "Path 69556",
    className: "cls-15",
    d: "M1214.484,1394.811l-3.431,1.985a.415.415,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.012a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1024.427 -1181.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69557",
    "data-name": "Path 69557",
    className: "cls-15",
    d: "M1251.391,1373.225l-3.43,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1055.744 -1163.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69558",
    "data-name": "Path 69558",
    className: "cls-15",
    d: "M1288.3,1351.639l-3.431,1.986a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1087.059 -1144.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69559",
    "data-name": "Path 69559",
    className: "cls-15",
    d: "M1325.2,1330.054l-3.43,1.985a.414.414,0,0,1-.42-.005l-3.216-1.947a.171.171,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1118.375 -1126.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69560",
    "data-name": "Path 69560",
    className: "cls-15",
    d: "M1362.112,1308.469l-3.43,1.985a.416.416,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.358.358,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.319",
    transform: "translate(-1149.691 -1108.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69561",
    "data-name": "Path 69561",
    className: "cls-15",
    d: "M1399.019,1286.883l-3.43,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.013a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1181.006 -1089.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69562",
    "data-name": "Path 69562",
    className: "cls-15",
    d: "M1435.926,1265.3l-3.43,1.985a.414.414,0,0,1-.42-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.359.359,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1212.323 -1071.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69563",
    "data-name": "Path 69563",
    className: "cls-15",
    d: "M1472.833,1243.714l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.359.359,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1243.638 -1053.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69564",
    "data-name": "Path 69564",
    className: "cls-14",
    d: "M1035.4,1549.837l-3.431,1.986a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.357.357,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-872.476 -1313.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69565",
    "data-name": "Path 69565",
    className: "cls-14",
    d: "M1072.31,1528.253l-3.431,1.985a.415.415,0,0,1-.42-.006l-3.216-1.947a.172.172,0,0,1,0-.3l3.478-2.013a.358.358,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-903.792 -1294.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69566",
    "data-name": "Path 69566",
    className: "cls-14",
    d: "M1109.215,1506.667l-3.431,1.986a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.36.36,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-935.106 -1276.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69567",
    "data-name": "Path 69567",
    className: "cls-14",
    d: "M1146.122,1485.081l-3.43,1.986a.413.413,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.478-2.013a.36.36,0,0,1,.364,0l3.224,1.952a.185.185,0,0,1,0,.319",
    transform: "translate(-966.422 -1258.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69568",
    "data-name": "Path 69568",
    className: "cls-14",
    d: "M1203.482,1383.888l-23.883,14.046a.414.414,0,0,1-.42-.005l-3.216-1.946a.171.171,0,0,1,0-.3l23.931-14.073a.357.357,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-997.738 -1172.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69569",
    "data-name": "Path 69569",
    className: "cls-15",
    d: "M1219.937,1441.912l-3.431,1.985a.414.414,0,0,1-.42-.006l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1029.055 -1221.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69570",
    "data-name": "Path 69570",
    className: "cls-15",
    d: "M1256.844,1420.326l-3.431,1.985a.414.414,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.356.356,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1060.37 -1203.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69571",
    "data-name": "Path 69571",
    className: "cls-15",
    d: "M1293.75,1398.74l-3.431,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.357.357,0,0,1,.363.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1091.685 -1184.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69572",
    "data-name": "Path 69572",
    className: "cls-15",
    d: "M1330.657,1377.155l-3.431,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.361.361,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1123.001 -1166.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69573",
    "data-name": "Path 69573",
    className: "cls-15",
    d: "M1367.564,1355.569l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.36.36,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1154.317 -1148.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69574",
    "data-name": "Path 69574",
    className: "cls-15",
    d: "M1404.471,1333.985l-3.431,1.985a.415.415,0,0,1-.419-.005l-3.216-1.946a.172.172,0,0,1,0-.3l3.479-2.013a.36.36,0,0,1,.364.005l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1185.632 -1129.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69575",
    "data-name": "Path 69575",
    className: "cls-15",
    d: "M1441.377,1312.4l-3.431,1.986a.415.415,0,0,1-.42-.006l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.358.358,0,0,1,.364,0l3.224,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1216.947 -1111.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69576",
    "data-name": "Path 69576",
    className: "cls-15",
    d: "M1478.284,1290.814l-3.431,1.985a.415.415,0,0,1-.42-.005l-3.216-1.947a.172.172,0,0,1,0-.3l3.479-2.012a.357.357,0,0,1,.364,0l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1248.262 -1093.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69577",
    "data-name": "Path 69577",
    className: "cls-15",
    d: "M1515.191,1269.228l-3.43,1.986a.414.414,0,0,1-.42-.006l-3.216-1.946a.171.171,0,0,1,0-.3l3.479-2.013a.358.358,0,0,1,.364.005l3.225,1.951a.185.185,0,0,1,0,.32",
    transform: "translate(-1279.578 -1074.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69578",
    "data-name": "Path 69578",
    className: "cls-11",
    d: "M1318.339,1466.177l-19.95,11.546a2.408,2.408,0,0,1-2.441-.033l-18.7-11.317a1,1,0,0,1,.014-1.723l20.228-11.706a2.086,2.086,0,0,1,2.115.029l18.751,11.346a1.077,1.077,0,0,1-.015,1.858",
    transform: "translate(-1083.335 -1232.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69579",
    "data-name": "Path 69579",
    className: "cls-16",
    d: "M866.155,250.479l6.538-3.722V225.166l-6.538,3.722Z",
    transform: "translate(-734.936 -191.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69580",
    "data-name": "Path 69580",
    className: "cls-16",
    d: "M952.565,151.438l6.538-3.722V117.433l-6.538,3.722Z",
    transform: "translate(-808.255 -99.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69581",
    "data-name": "Path 69581",
    className: "cls-16",
    d: "M1038.974,44.164l6.538-3.722V0l-6.538,3.722Z",
    transform: "translate(-881.574 0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69582",
    "data-name": "Path 69582",
    className: "cls-16",
    d: "M1125.384,99.409l6.538-3.722V74.1l-6.538,3.722Z",
    transform: "translate(-954.893 -62.871)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67315",
    "data-name": "Group 67315",
    transform: "translate(85.183 99.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69583",
    "data-name": "Path 69583",
    className: "cls-17",
    d: "M562.277,759.706l68.128-39.486V658.733L562.277,698.22Z",
    transform: "translate(-562.277 -658.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69588",
    "data-name": "Path 69588",
    className: "cls-18",
    d: "M638.946,955.381V990.1l51.724-29.531",
    transform: "translate(-627.331 -910.44)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5940",
    "data-name": "Line 5940",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(17.977 41.918)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5941",
    "data-name": "Line 5941",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(24.2 38.301)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5942",
    "data-name": "Line 5942",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(30.422 34.682)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5943",
    "data-name": "Line 5943",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(36.645 31.064)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5944",
    "data-name": "Line 5944",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(42.867 27.446)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5945",
    "data-name": "Line 5945",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(49.089 23.828)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5946",
    "data-name": "Line 5946",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(55.312 20.21)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5947",
    "data-name": "Line 5947",
    className: "cls-19",
    y1: 34.107,
    transform: "translate(61.534 16.592)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5948",
    "data-name": "Line 5948",
    className: "cls-19",
    y1: 29.531,
    x2: 51.724,
    transform: "translate(11.615 44.941)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5949",
    "data-name": "Line 5949",
    className: "cls-19",
    y1: 29.531,
    x2: 51.724,
    transform: "translate(11.615 39.731)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5950",
    "data-name": "Line 5950",
    className: "cls-19",
    y1: 29.531,
    x2: 51.724,
    transform: "translate(11.615 34.522)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5951",
    "data-name": "Line 5951",
    className: "cls-19",
    y1: 29.531,
    x2: 51.724,
    transform: "translate(11.615 29.312)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5952",
    "data-name": "Line 5952",
    className: "cls-19",
    y1: 29.531,
    x2: 51.724,
    transform: "translate(11.615 24.102)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5953",
    "data-name": "Line 5953",
    className: "cls-19",
    y1: 29.531,
    x2: 51.724,
    transform: "translate(11.615 18.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69762",
    "data-name": "Path 69762",
    className: "cls-20",
    d: "M887.143,910.7l6.053-3.445V887.262l-6.053,3.445Z",
    transform: "translate(-837.927 -852.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69763",
    "data-name": "Path 69763",
    className: "cls-20",
    d: "M807.149,892.991l6.053-3.445V858.074l-6.053,3.445Z",
    transform: "translate(-770.051 -827.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69764",
    "data-name": "Path 69764",
    className: "cls-20",
    d: "M720.982,961.47l6.053-3.446V929.99l-6.053,3.446Z",
    transform: "translate(-696.939 -888.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69765",
    "data-name": "Path 69765",
    className: "cls-20",
    d: "M640.989,1053.158l6.053-3.445v-19.988l-6.053,3.445Z",
    transform: "translate(-629.064 -973.52)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69589",
    "data-name": "Path 69589",
    className: "cls-21",
    d: "M638.946,832.889s6.833-.333,7.179.129,2.543-2.312,2.543-2.312l4.855.578,5.432-8.736,6.01-5.5,9.941-2.867.578-7.86,5.2-5.895V794.3l8.971-11.941",
    transform: "translate(-542.148 -663.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69590",
    "data-name": "Path 69590",
    className: "cls-22",
    d: "M634.461,1196.814l8.568-4.979a1.693,1.693,0,0,0,.813-1.284v-.159c0-.448-.366-.6-.813-.344l-8.568,4.979a1.7,1.7,0,0,0-.813,1.284v.16c0,.447.366.6.813.343",
    transform: "translate(-537.652 -1009.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69591",
    "data-name": "Path 69591",
    className: "cls-22",
    d: "M597.934,984.134l4.284-2.49a.847.847,0,0,0,.407-.642v-.08c0-.224-.183-.3-.407-.172l-4.284,2.49a.847.847,0,0,0-.407.642v.08c0,.224.183.3.407.172",
    transform: "translate(-507.004 -832.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69592",
    "data-name": "Path 69592",
    className: "cls-22",
    d: "M597.934,1019.153l4.284-2.489a.848.848,0,0,0,.407-.642v-.079c0-.224-.183-.3-.407-.172l-4.284,2.49a.847.847,0,0,0-.407.642v.08c0,.224.183.3.407.172",
    transform: "translate(-507.004 -861.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69593",
    "data-name": "Path 69593",
    className: "cls-22",
    d: "M597.934,1054.172l4.284-2.49a.847.847,0,0,0,.407-.642v-.08c0-.224-.183-.3-.407-.172l-4.284,2.49a.846.846,0,0,0-.407.642v.08c0,.224.183.3.407.172",
    transform: "translate(-507.004 -891.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69594",
    "data-name": "Path 69594",
    className: "cls-22",
    d: "M597.934,1089.191l4.284-2.49a.847.847,0,0,0,.407-.642v-.08c0-.224-.183-.3-.407-.171l-4.284,2.489a.847.847,0,0,0-.407.642v.08c0,.223.183.3.407.171",
    transform: "translate(-507.004 -921.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69595",
    "data-name": "Path 69595",
    className: "cls-22",
    d: "M597.934,1124.21l4.284-2.49a.847.847,0,0,0,.407-.641V1121c0-.224-.183-.3-.407-.172l-4.284,2.49a.846.846,0,0,0-.407.642v.08c0,.224.183.3.407.172",
    transform: "translate(-507.004 -950.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69596",
    "data-name": "Path 69596",
    className: "cls-22",
    d: "M597.934,1159.229l4.284-2.489a.848.848,0,0,0,.407-.642v-.08c0-.224-.183-.3-.407-.172l-4.284,2.49a.847.847,0,0,0-.407.642v.08c0,.224.183.3.407.172",
    transform: "translate(-507.004 -980.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69597",
    "data-name": "Path 69597",
    className: "cls-22",
    d: "M730.438,1140.7l8.569-4.979a1.7,1.7,0,0,0,.813-1.284v-.159c0-.448-.366-.6-.813-.344l-8.569,4.979a1.694,1.694,0,0,0-.813,1.283v.16c0,.447.366.6.813.344",
    transform: "translate(-619.089 -962.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69598",
    "data-name": "Path 69598",
    className: "cls-22",
    d: "M826.413,1084.591l8.569-4.979a1.694,1.694,0,0,0,.813-1.283v-.159c0-.448-.366-.6-.813-.344l-8.569,4.979a1.694,1.694,0,0,0-.813,1.283v.16c0,.447.366.6.813.344",
    transform: "translate(-700.525 -914.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69599",
    "data-name": "Path 69599",
    className: "cls-22",
    d: "M922.389,1028.48l8.569-4.979a1.7,1.7,0,0,0,.813-1.284v-.159c0-.448-.366-.6-.813-.344l-8.569,4.979a1.7,1.7,0,0,0-.813,1.283v.16c0,.447.366.6.813.344",
    transform: "translate(-781.961 -866.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69600",
    "data-name": "Path 69600",
    className: "cls-23",
    d: "M1962.307,1350.23l-14.649-8.677v57.2l14.649,8.677Z",
    transform: "translate(-1652.595 -1138.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69601",
    "data-name": "Path 69601",
    className: "cls-24",
    d: "M2044.355,1355.209l13.048-7.914v57.2l-13.048,7.914Z",
    transform: "translate(-1734.643 -1143.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69602",
    "data-name": "Path 69602",
    className: "cls-25",
    d: "M1962.307,1306.152l-14.649-8.784,13.048-7.889,14.649,8.784Z",
    transform: "translate(-1652.595 -1094.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69603",
    "data-name": "Path 69603",
    className: "cls-23",
    d: "M1817.552,1539.172,1802.9,1530.5v41.681l14.649,8.677Z",
    transform: "translate(-1529.77 -1298.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69604",
    "data-name": "Path 69604",
    className: "cls-24",
    d: "M1899.6,1544.149l13.048-7.914v41.682l-13.048,7.914Z",
    transform: "translate(-1611.818 -1303.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69605",
    "data-name": "Path 69605",
    className: "cls-25",
    d: "M1817.551,1495.091l-14.649-8.784,13.047-7.889,14.649,8.784Z",
    transform: "translate(-1529.769 -1254.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69606",
    "data-name": "Path 69606",
    className: "cls-23",
    d: "M1672.794,1710.168l-14.649-8.677v28.88l14.649,8.677Z",
    transform: "translate(-1406.942 -1443.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69607",
    "data-name": "Path 69607",
    className: "cls-24",
    d: "M1754.844,1715.147l13.048-7.914v28.879l-13.048,7.914Z",
    transform: "translate(-1488.992 -1448.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69608",
    "data-name": "Path 69608",
    className: "cls-25",
    d: "M1672.794,1666.09l-14.649-8.784,13.048-7.889,14.649,8.784Z",
    transform: "translate(-1406.942 -1399.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69609",
    "data-name": "Path 69609",
    className: "cls-23",
    d: "M1528.038,1868.623l-14.649-8.677v17.978l14.649,8.677Z",
    transform: "translate(-1284.116 -1578.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69610",
    "data-name": "Path 69610",
    className: "cls-24",
    d: "M1610.087,1873.6l13.048-7.914v17.977l-13.048,7.915Z",
    transform: "translate(-1366.165 -1583.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69611",
    "data-name": "Path 69611",
    className: "cls-25",
    d: "M1528.038,1824.544l-14.649-8.784,13.048-7.889,14.649,8.784Z",
    transform: "translate(-1284.116 -1533.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69612",
    "data-name": "Path 69612",
    className: "cls-26",
    d: "M1063.27,536.313c.082-.138.164-.282.246-.42a41.509,41.509,0,0,1,13.679-14.182c6.206-3.72,11.7-3.978,15.089-1.342l4.646,3.158-2.214-.047a13.468,13.468,0,0,1,1.117,5.7c0,4.979-1.948,10.665-5.132,15.915-.508.841-1.046,1.671-1.615,2.482a43.306,43.306,0,0,1-7,7.834,34.84,34.84,0,0,1-3.63,2.784c-.282.185-.559.364-.841.543-.138.087-.282.174-.42.256s-.287.169-.426.251c-.282.159-.559.313-.841.466a18.636,18.636,0,0,1-7.573,2.353c-.329.021-.651.026-.964.021a10.138,10.138,0,0,1-2.087-.251,8.467,8.467,0,0,1-1.621-.543c-3.179-1.43-5.132-4.784-5.132-9.757,0-4.753,1.779-10.162,4.717-15.218",
    transform: "translate(-898.186 -440.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69613",
    "data-name": "Path 69613",
    className: "cls-27",
    d: "M1058.553,650.632c0,4.973,1.318,8.569,4.5,10,.513.231,3.114,1.817,3.683,1.946.661.154-.068-1.408.66-1.393.313.005.635,0,.964-.021l1.354-1.523-1.7-21.606-4.743-2.62c-2.938,5.056-4.717,10.465-4.717,15.218",
    transform: "translate(-898.186 -539.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69614",
    "data-name": "Path 69614",
    className: "cls-28",
    d: "M1088.234,571.583c0,4.973,1.953,8.327,5.132,9.757a8.5,8.5,0,0,0,1.621.544,10.159,10.159,0,0,0,2.087.251,17.68,17.68,0,0,0,8.537-2.374c.282-.154.559-.308.841-.467.139-.082.282-.169.426-.251s.282-.169.421-.256c.282-.179.559-.359.841-.543a34.885,34.885,0,0,0,3.63-2.784,43.3,43.3,0,0,0,7-7.834c.569-.81,1.107-1.641,1.615-2.481,3.184-5.25,5.132-10.937,5.132-15.915,0-10.3-8.347-13.633-18.637-7.465a41.511,41.511,0,0,0-13.679,14.182c-3.082,5.173-4.963,10.752-4.963,15.638",
    transform: "translate(-923.371 -457.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69615",
    "data-name": "Path 69615",
    className: "cls-29",
    d: "M1088.234,668.347c0,4.973,1.953,8.327,5.132,9.757a8.49,8.49,0,0,0,1.621.543,10.151,10.151,0,0,0,2.087.251l9.8-21.037-13.679-5.153c-3.082,5.173-4.963,10.752-4.963,15.638",
    transform: "translate(-923.371 -553.826)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67241",
    "data-name": "Group 67241",
    transform: "translate(173.702 104.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67240",
    "data-name": "Group 67240",
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25199",
    "data-name": "Rectangle 25199",
    className: "cls-31",
    width: 16.111,
    height: 22.054,
    transform: "translate(-1.448 0.1) rotate(-3.945)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67252",
    "data-name": "Group 67252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67251",
    "data-name": "Group 67251",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69617",
    "data-name": "Path 69617",
    className: "cls-4",
    d: "M58.756,830.058,2.23,864.209A4.489,4.489,0,0,0,0,868.089v62.523c0,1.915,4.218,4.339,5.872,3.376L59.7,898.932a3.906,3.906,0,0,0,1.94-3.375l2.989-63.146c0-1.477-4.591-3.1-5.868-2.353",
    transform: "translate(0 -704.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69618",
    "data-name": "Path 69618",
    className: "cls-32",
    d: "M79.46,839.134,22.934,873.286a4.49,4.49,0,0,0-2.23,3.879v62.523a2.482,2.482,0,0,0,3.731,2.145L80.4,908.009a3.906,3.906,0,0,0,1.94-3.375V840.789a1.915,1.915,0,0,0-2.879-1.655",
    transform: "translate(-17.567 -711.785)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67244",
    "data-name": "Group 67244",
    className: "cls-33",
    transform: "translate(26.369 143.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67243",
    "data-name": "Group 67243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67242",
    "data-name": "Group 67242",
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69619",
    "data-name": "Path 69619",
    className: "cls-35",
    d: "M205.568,949.625v1.7l-31.514,19.192v-1.7Z",
    transform: "translate(-174.054 -949.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69620",
    "data-name": "Path 69620",
    className: "cls-35",
    d: "M205.568,982.091v1.7l-31.514,19.129v-1.7Z",
    transform: "translate(-174.054 -977.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69621",
    "data-name": "Path 69621",
    className: "cls-35",
    d: "M205.568,1014.557v1.7l-31.514,19.129v-1.7Z",
    transform: "translate(-174.054 -1004.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69622",
    "data-name": "Path 69622",
    className: "cls-35",
    d: "M205.568,1047.023v1.7l-31.514,19.129v-1.7Z",
    transform: "translate(-174.054 -1032.268)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67247",
    "data-name": "Group 67247",
    className: "cls-33",
    transform: "translate(11.382 172.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67246",
    "data-name": "Group 67246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67245",
    "data-name": "Group 67245",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69623",
    "data-name": "Path 69623",
    className: "cls-37",
    d: "M143.1,1135.951v1.7l-42.667,25.7v-1.7Z",
    transform: "translate(-96.604 -1135.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69624",
    "data-name": "Path 69624",
    className: "cls-37",
    d: "M121.634,1168.417v1.7l-46.5,27.849v-1.7Z",
    transform: "translate(-75.134 -1163.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69625",
    "data-name": "Path 69625",
    className: "cls-37",
    d: "M121.634,1200.883v1.7l-46.5,27.849v-1.7Z",
    transform: "translate(-75.134 -1191.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69626",
    "data-name": "Path 69626",
    className: "cls-37",
    d: "M121.634,1233.348v1.7l-46.5,27.849v-1.7Z",
    transform: "translate(-75.134 -1218.593)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69627",
    "data-name": "Path 69627",
    className: "cls-38",
    d: "M57.315,1092.052v16.4l15.042-8.72v-16.46Z",
    transform: "translate(-48.632 -919.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69628",
    "data-name": "Path 69628",
    className: "cls-39",
    d: "M251,1700.092c0-10.683-15.012-19.358-33.539-19.358-18.509,0-33.539,8.675-33.539,19.358a10.752,10.752,0,0,1,0,3.494,10.746,10.746,0,0,1,0,3.493c0,10.684,15.029,19.359,33.539,19.359,18.146,0,32.9-8.312,33.5-18.683a4.413,4.413,0,0,0,.035-.675Zm-33.539,15.151c-12.4,0-22.8-4.978-25.538-11.657,2.737-6.679,13.136-11.657,25.538-11.657s22.8,4.978,25.539,11.656c-2.726,6.68-13.116,11.658-25.539,11.658",
    transform: "translate(-156.063 -1426.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69629",
    "data-name": "Path 69629",
    className: "cls-40",
    d: "M217.465,1667.146c-18.515,0-33.542,8.678-33.542,19.356s15.028,19.365,33.542,19.365c18.145,0,32.892-8.316,33.5-18.686a4.5,4.5,0,0,0,.034-.678c0-10.678-15.014-19.356-33.536-19.356m26.22,19.891c-.014.232-.034.473-.069.7-1.075,7.788-12.363,13.918-26.152,13.918-13.754,0-25.049-6.116-26.166-13.891a8.553,8.553,0,0,1-.089-1.261c0-8.356,11.768-15.144,26.254-15.144s26.248,6.788,26.248,15.144a3.5,3.5,0,0,1-.027.535",
    transform: "translate(-156.059 -1414.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69630",
    "data-name": "Path 69630",
    className: "cls-41",
    d: "M578.663,1892.324c.017-.123.04-.246.063-.369.016-.084.031-.168.05-.252s.038-.157.058-.236c.028-.11.056-.22.088-.33.019-.064.038-.127.058-.191q.058-.185.124-.37c.018-.051.036-.1.055-.153.064-.17.131-.34.2-.508l.024-.053c.067-.152.139-.3.213-.453l.069-.136c.073-.141.148-.28.226-.418l.045-.08c.093-.16.191-.318.291-.473.029-.045.06-.088.089-.133q.112-.168.229-.33c.042-.059.085-.117.128-.174.068-.091.138-.179.209-.267s.119-.147.179-.219.117-.133.176-.2q.151-.168.308-.328c.051-.052.1-.1.154-.153a8.365,8.365,0,0,1,.65-.572c.039-.031.079-.06.119-.09a7.02,7.02,0,0,1,.721-.488,5.662,5.662,0,0,1,.582-.289c.061-.026.121-.049.181-.072q.165-.064.326-.113c.069-.021.138-.041.205-.057s.127-.029.189-.04c.083-.016.165-.028.245-.038.046-.005.093-.01.139-.014a2.86,2.86,0,0,1,.3-.005c.023,0,.047,0,.069,0a2.651,2.651,0,0,1,.341.043c.028.005.054.013.081.019a2.41,2.41,0,0,1,.255.073c.026.01.052.017.078.027a2.216,2.216,0,0,1,.3.144L562.346,1871l-.026-.014a2.118,2.118,0,0,0-.232-.113c-.015-.006-.03-.01-.046-.016s-.052-.018-.078-.027-.079-.031-.12-.043-.09-.021-.134-.031c-.027-.006-.054-.014-.081-.019l-.044-.01a2.543,2.543,0,0,0-.279-.033h-.018c-.022,0-.046,0-.068,0-.073,0-.145-.005-.219,0-.025,0-.052.006-.077.008-.046,0-.092.009-.139.014s-.085.006-.129.013-.077.017-.115.024c-.063.012-.126.025-.19.041-.034.008-.067.012-.1.022s-.069.025-.1.035q-.161.048-.326.113c-.039.015-.076.023-.115.039-.022.009-.045.024-.066.033a5.538,5.538,0,0,0-.582.289,7.044,7.044,0,0,0-.721.488c-.04.03-.08.059-.119.09a8.367,8.367,0,0,0-.651.572c-.018.017-.037.031-.055.048-.034.033-.065.071-.1.1-.1.107-.207.216-.308.328-.032.036-.066.068-.1.1s-.051.063-.077.094c-.061.072-.121.145-.18.219-.039.048-.08.094-.118.143s-.06.082-.09.122q-.065.087-.129.175c-.029.04-.06.079-.088.12-.048.069-.094.139-.14.209-.03.045-.061.089-.09.134l-.037.056c-.082.129-.162.259-.239.391l-.015.027c-.015.026-.03.053-.045.08-.053.094-.107.188-.157.283-.024.044-.045.089-.068.134l-.069.137c-.02.041-.042.081-.062.121-.053.109-.1.219-.15.329-.008.019-.018.038-.026.056a.164.164,0,0,1-.007.016q-.089.207-.17.415c-.01.026-.018.051-.027.077-.019.051-.037.1-.055.153-.025.069-.051.138-.074.207s-.033.109-.05.163-.04.127-.058.191c-.012.039-.025.078-.036.117-.02.071-.034.142-.052.213s-.04.158-.058.236c-.006.027-.014.055-.02.082-.012.057-.018.113-.029.17-.024.124-.046.247-.064.369,0,.033-.013.068-.018.1s0,.063-.006.094a6.866,6.866,0,0,0-.053.812,3.236,3.236,0,0,0,1.348,2.966l24.138,14.027a3.237,3.237,0,0,1-1.348-2.966,6.906,6.906,0,0,1,.053-.812c.008-.065.014-.13.024-.2",
    transform: "translate(-470.452 -1587.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69631",
    "data-name": "Path 69631",
    className: "cls-42",
    d: "M718.385,1963.908c2.554-1.475,4.63-.292,4.638,2.642a10.15,10.15,0,0,1-4.607,7.981c-2.554,1.475-4.629.292-4.638-2.643a10.152,10.152,0,0,1,4.607-7.98",
    transform: "translate(-605.643 -1665.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69632",
    "data-name": "Path 69632",
    className: "cls-43",
    d: "M721.212,1974.974c.026-.181.058-.363.093-.545.024-.125.045-.248.073-.373s.056-.232.086-.349c.041-.162.082-.325.129-.487.028-.094.057-.188.086-.282q.086-.273.183-.546c.027-.075.053-.15.081-.226.095-.251.194-.5.3-.75.011-.026.024-.053.036-.079q.149-.337.315-.669c.033-.068.068-.135.1-.2q.16-.311.334-.616c.022-.039.043-.08.066-.118.137-.237.281-.47.43-.7.043-.067.088-.131.132-.2q.165-.247.338-.488c.063-.086.126-.172.19-.257.1-.134.2-.264.308-.394.088-.109.176-.217.265-.323s.172-.2.259-.293q.224-.249.455-.485c.075-.077.151-.153.227-.227a12.554,12.554,0,0,1,.961-.845c.058-.046.117-.088.176-.132a10.294,10.294,0,0,1,1.065-.72,8.242,8.242,0,0,1,.859-.428c.09-.039.179-.073.268-.107.163-.063.324-.119.482-.166.1-.03.2-.061.3-.084s.187-.043.28-.06c.122-.023.243-.042.361-.056.069-.008.138-.016.205-.021q.222-.015.436-.009c.034,0,.069,0,.1,0a3.826,3.826,0,0,1,.5.064c.041.008.08.018.12.028a3.366,3.366,0,0,1,.377.108c.038.013.077.026.115.04a3.312,3.312,0,0,1,.448.213L697.1,1943.468l-.038-.021a3.235,3.235,0,0,0-.343-.167c-.022-.009-.045-.015-.068-.024-.038-.015-.076-.027-.115-.041-.059-.021-.117-.045-.178-.063s-.132-.031-.2-.046c-.04-.009-.079-.02-.12-.028-.022,0-.043-.011-.065-.015a3.883,3.883,0,0,0-.412-.048h-.027c-.033,0-.068,0-.1,0-.107,0-.214-.008-.324,0-.037,0-.076.009-.114.011-.068,0-.136.013-.205.021s-.126.01-.19.019-.115.026-.171.037c-.093.017-.186.037-.28.06-.05.012-.1.018-.15.032s-.1.038-.153.053c-.158.047-.319.1-.482.166-.057.022-.112.035-.169.059-.032.013-.066.035-.1.049a8.225,8.225,0,0,0-.86.427,10.3,10.3,0,0,0-1.065.72c-.059.044-.118.086-.176.133a12.32,12.32,0,0,0-.961.845c-.026.025-.055.045-.081.071-.05.049-.1.105-.146.155q-.232.236-.455.485c-.047.053-.1.1-.145.155s-.076.094-.114.139c-.091.106-.179.215-.267.324-.057.072-.117.139-.173.212s-.088.12-.133.18q-.1.128-.191.259c-.043.059-.088.117-.13.177-.071.1-.138.205-.207.309-.045.067-.09.132-.133.2-.018.028-.037.054-.055.082q-.182.285-.353.577l-.022.039c-.023.039-.044.079-.066.119-.079.138-.158.277-.232.417-.035.066-.067.133-.1.2s-.069.135-.1.2-.062.119-.091.179c-.078.161-.151.323-.223.485-.012.028-.026.055-.038.084l-.011.023q-.132.3-.25.612c-.015.038-.026.075-.04.114-.029.075-.054.151-.082.226-.036.1-.075.2-.11.3-.026.08-.048.161-.073.241s-.058.188-.086.282c-.017.058-.036.115-.052.173-.029.105-.051.209-.077.314s-.06.233-.086.349c-.009.04-.021.081-.03.121-.018.084-.027.168-.043.251-.035.183-.068.364-.094.545-.007.051-.019.1-.026.151s0,.092-.009.139a10.065,10.065,0,0,0-.078,1.2c.006,2.154.766,3.67,1.992,4.382l35.665,20.726c-1.226-.712-1.986-2.228-1.992-4.382a10.055,10.055,0,0,1,.078-1.2c.011-.1.021-.193.035-.29",
    transform: "translate(-581.593 -1648.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69633",
    "data-name": "Path 69633",
    className: "cls-41",
    d: "M927.657,2080.742c3.774-2.179,6.84-.431,6.852,3.9a15,15,0,0,1-6.808,11.791c-3.774,2.179-6.84.432-6.852-3.9a15,15,0,0,1,6.808-11.791",
    transform: "translate(-781.344 -1764.721)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67250",
    "data-name": "Group 67250",
    className: "cls-44",
    transform: "translate(35.241 259.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67249",
    "data-name": "Group 67249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67248",
    "data-name": "Group 67248",
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69634",
    "data-name": "Path 69634",
    className: "cls-46",
    d: "M284.935,1725.409c-1.075,7.789-12.363,13.919-26.152,13.919-13.754,0-25.049-6.116-26.165-13.891,1.116-7.775,12.411-13.892,26.165-13.892s25.022,6.1,26.152,13.864",
    transform: "translate(-232.618 -1711.545)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69635",
    "data-name": "Path 69635",
    className: "cls-4",
    d: "M242.655,263.478,162.641,311.6c-2.288,1.318-6.034-1.829-6.034-4.469V273.712a7.855,7.855,0,0,1,3.933-6.806L242,219.963c2.193-1.264,6.627.339,6.627,2.87l-1.7,33.243a8.542,8.542,0,0,1-4.277,7.4",
    transform: "translate(-132.882 -186.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69636",
    "data-name": "Path 69636",
    className: "cls-47",
    d: "M258.212,271.5l-80.9,46.622a3.432,3.432,0,0,1-5.145-2.974V281.73a7.855,7.855,0,0,1,3.933-6.806l81.461-46.944a3.289,3.289,0,0,1,4.932,2.85v33.263a8.543,8.543,0,0,1-4.277,7.4",
    transform: "translate(-146.082 -193.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69637",
    "data-name": "Path 69637",
    className: "cls-48",
    d: "M577.161,335.68a23.758,23.758,0,0,1-3.793,11.767q-.563.933-1.2,1.835a30.52,30.52,0,0,1-7.858,7.85c-.206.136-.412.268-.621.4-.1.065-.209.128-.312.19s-.209.125-.312.184c-.209.119-.415.234-.621.345-2.978,1.586-5.695,2.073-7.854,1.572a6.4,6.4,0,0,1-1.2-.4c-2.35-1.059-3.792-3.539-3.792-7.216,0-7.609,6.17-17.48,13.78-22.043s13.78-2.093,13.78,5.517",
    transform: "translate(-466.339 -278.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69638",
    "data-name": "Path 69638",
    className: "cls-49",
    d: "M601.718,391.728c0,.09,0,.178-.005.269q-.476.788-1.011,1.55a25.784,25.784,0,0,1-6.638,6.632c-.174.115-.348.227-.524.338-.087.055-.177.109-.264.161s-.177.106-.264.155c-.177.1-.351.2-.525.292a9.764,9.764,0,0,1-6.635,1.328,5.371,5.371,0,0,1-1.013-.339c0-.085-.005-.173-.005-.26,0-3.941,2.7-8.868,6.351-11.99-1.129-.024-1.883-.818-1.883-2.246,0-2.193,1.781-5.042,3.974-6.357s3.974-.6,3.974,1.591a7.668,7.668,0,0,1-1.883,4.5c3.651-1.258,6.351.431,6.351,4.372",
    transform: "translate(-496.234 -322.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69639",
    "data-name": "Path 69639",
    className: "cls-50",
    d: "M488.407,459.449l1.553-.9a2.6,2.6,0,0,0,1.246-1.966v-.244c0-.685-.561-.922-1.246-.526l-1.553.9a2.6,2.6,0,0,0-1.246,1.966v.244c0,.685.561.922,1.246.526",
    transform: "translate(-413.358 -386.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69640",
    "data-name": "Path 69640",
    className: "cls-50",
    d: "M210.281,503.142l37.71-21.79a2.6,2.6,0,0,0,1.246-1.966v-.244c0-.685-.561-.922-1.246-.526l-37.71,21.79a2.6,2.6,0,0,0-1.246,1.966v.244c0,.685.561.922,1.246.526",
    transform: "translate(-177.367 -405.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69641",
    "data-name": "Path 69641",
    className: "cls-50",
    d: "M488.407,502.106l1.553-.9a2.6,2.6,0,0,0,1.246-1.966V499c0-.685-.561-.922-1.246-.526l-1.553.9a2.6,2.6,0,0,0-1.246,1.966v.244c0,.685.561.922,1.246.526",
    transform: "translate(-413.358 -422.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69642",
    "data-name": "Path 69642",
    className: "cls-50",
    d: "M210.281,545.8l37.71-21.79a2.6,2.6,0,0,0,1.246-1.966V521.8c0-.685-.561-.922-1.246-.526l-37.71,21.79a2.6,2.6,0,0,0-1.246,1.966v.244c0,.685.561.922,1.246.526",
    transform: "translate(-177.367 -442.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69643",
    "data-name": "Path 69643",
    className: "cls-50",
    d: "M488.407,544.765l1.553-.9a2.6,2.6,0,0,0,1.246-1.966v-.244c0-.685-.561-.922-1.246-.526l-1.553.9a2.6,2.6,0,0,0-1.246,1.966v.244c0,.685.561.922,1.246.526",
    transform: "translate(-413.358 -458.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69644",
    "data-name": "Path 69644",
    className: "cls-50",
    d: "M210.281,588.459l37.71-21.79a2.6,2.6,0,0,0,1.246-1.966v-.244c0-.685-.561-.922-1.246-.526l-37.71,21.79a2.6,2.6,0,0,0-1.246,1.966v.244c0,.685.561.922,1.246.526",
    transform: "translate(-177.367 -478.335)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67254",
    "data-name": "Group 67254",
    transform: "translate(252.235 29.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67253",
    "data-name": "Group 67253",
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25204",
    "data-name": "Rectangle 25204",
    className: "cls-52",
    width: 27.898,
    height: 48.182,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67256",
    "data-name": "Group 67256",
    transform: "translate(259.208 33.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67255",
    "data-name": "Group 67255",
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25205",
    "data-name": "Rectangle 25205",
    className: "cls-54",
    width: 22.756,
    height: 48.182,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67261",
    "data-name": "Group 67261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67260",
    "data-name": "Group 67260",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69647",
    "data-name": "Path 69647",
    className: "cls-55",
    d: "M1765.81,196.124l6.973,3.792-5.081,7.735-6.973-3.792Z",
    transform: "translate(-1493.986 -166.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69648",
    "data-name": "Path 69648",
    className: "cls-55",
    d: "M1664.96,470.81l6.973,3.792.323,6.568-6.973-3.792Z",
    transform: "translate(-1412.725 -399.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69649",
    "data-name": "Path 69649",
    className: "cls-56",
    d: "M1569.224,172.745c-3.409-1.955-18.644,5.635-24.2,8.74-5.43,3.035-9.988,6.4-13.389,12.013l-6.973-3.792c4.632-7.653,11.273-14.561,18.677-18.7,7.53-4.209,14.272-4.674,18.912-2.054Z",
    transform: "translate(-1293.682 -141.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69650",
    "data-name": "Path 69650",
    className: "cls-57",
    d: "M1491.048,360.714a30.144,30.144,0,0,0-1.28,9.568c0,9.258,4.445,10.46,13.3,6.941l6.973,3.792-5.625,6.308c-12.645,5.648-23.7-2.926-23.7-15.951a37.012,37.012,0,0,1,3.359-14.45Z",
    transform: "translate(-1256.393 -302.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69651",
    "data-name": "Path 69651",
    className: "cls-58",
    d: "M1603.3,201.284c-3.409-1.955-8.382-1.623-13.937,1.482a39.067,39.067,0,0,0-13.7,13.711l-4.974-1.739c4.632-7.653,11.273-14.561,18.677-18.7,7.529-4.209,14.271-4.674,18.912-2.054Z",
    transform: "translate(-1332.734 -163.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69652",
    "data-name": "Path 69652",
    className: "cls-59",
    d: "M1535.154,384a25.656,25.656,0,0,0-1.685,8.645c0,9.258,6.769,13.131,15.624,9.612l.126,6.747c-12.645,5.648-22.478.427-22.478-12.6a37.012,37.012,0,0,1,3.359-14.45Z",
    transform: "translate(-1295.446 -324.088)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67259",
    "data-name": "Group 67259",
    className: "cls-33",
    transform: "translate(163.148 119.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67258",
    "data-name": "Group 67258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67257",
    "data-name": "Group 67257",
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69653",
    "data-name": "Path 69653",
    className: "cls-50",
    d: "M1136.182,786.51v1.962l-30.151,17.6v-1.962Z",
    transform: "translate(-1101.619 -786.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69654",
    "data-name": "Path 69654",
    className: "cls-50",
    d: "M1111.469,823.879v1.962l-34.564,20.073v-1.962Z",
    transform: "translate(-1076.906 -818.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69655",
    "data-name": "Path 69655",
    className: "cls-50",
    d: "M1111.469,861.248v1.962l-34.564,20.073v-1.962Z",
    transform: "translate(-1076.906 -849.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69656",
    "data-name": "Path 69656",
    className: "cls-50",
    d: "M1111.469,898.618v1.962l-34.564,20.073v-1.962Z",
    transform: "translate(-1076.906 -881.634)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69657",
    "data-name": "Path 69657",
    className: "cls-4",
    d: "M1183.169,631.8l103.037-59.872a5.324,5.324,0,0,1,8,4.6v90.122a9.768,9.768,0,0,1-4.86,8.445L1187.7,734.165a6.675,6.675,0,0,1-10.028-5.771V641.357a11.05,11.05,0,0,1,5.5-9.555",
    transform: "translate(-999.257 -484.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69658",
    "data-name": "Path 69658",
    className: "cls-48",
    d: "M1206.956,641.917l103.037-59.872a5.324,5.324,0,0,1,8,4.6V676.77a9.768,9.768,0,0,1-4.86,8.445l-101.646,59.064a6.675,6.675,0,0,1-10.028-5.771V651.472a11.051,11.051,0,0,1,5.5-9.555",
    transform: "translate(-1019.441 -493.249)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_69659",
    "data-name": "Path 69659",
    className: "cls-61",
    transform: "translate(-1019.441 -493.249)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1206.956,641.917l103.037-59.872a5.324,5.324,0,0,1,8,4.6V676.77a9.768,9.768,0,0,1-4.86,8.445l-101.646,59.064a6.675,6.675,0,0,1-10.028-5.771V651.472A11.051,11.051,0,0,1,1206.956,641.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M 1312.658935546875 583.3165283203125 C 1312.079345703125 583.3165283203125 1311.520385742188 583.4705810546875 1310.997436523438 583.7744140625 L 1207.960571289062 643.6466064453125 C 1205.182739257812 645.2608032226562 1203.45703125 648.2593994140625 1203.45703125 651.47216796875 L 1203.45703125 738.50830078125 C 1203.45703125 739.7981567382812 1203.9609375 740.9913940429688 1204.876098632812 741.8682861328125 C 1205.754638671875 742.710205078125 1206.945068359375 743.1930541992188 1208.142211914062 743.1930541992188 C 1208.95947265625 743.1930541992188 1209.74609375 742.9767456054688 1210.480224609375 742.5501708984375 L 1312.12646484375 683.4864501953125 C 1314.510375976562 682.1011962890625 1315.9912109375 679.5277099609375 1315.9912109375 676.770263671875 L 1315.9912109375 586.648193359375 C 1315.9912109375 585.472412109375 1315.443481445312 584.7008056640625 1314.984008789062 584.2605590820312 C 1314.35791015625 583.6605834960938 1313.510498046875 583.3165283203125 1312.658935546875 583.3165283203125 M 1312.658935546875 581.3165283203125 C 1315.439331054688 581.3165283203125 1317.9912109375 583.5392456054688 1317.9912109375 586.648193359375 L 1317.9912109375 676.770263671875 C 1317.9912109375 680.250244140625 1316.139892578125 683.4674072265625 1313.13134765625 685.2156982421875 L 1211.485107421875 744.2794189453125 C 1207.035034179688 746.865234375 1201.45703125 743.6547241210938 1201.45703125 738.50830078125 L 1201.45703125 651.47216796875 C 1201.45703125 647.53515625 1203.551513671875 643.8955078125 1206.955810546875 641.9173583984375 L 1309.99267578125 582.045166015625 C 1310.853759765625 581.5447998046875 1311.768310546875 581.3165283203125 1312.658935546875 581.3165283203125 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67314",
    "data-name": "Group 67314",
    transform: "translate(204.882 123.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69660",
    "data-name": "Path 69660",
    className: "cls-18",
    d: "M1352.389,1034.471v56.86l73.706-42.081",
    transform: "translate(-1352.389 -1001.463)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5954",
    "data-name": "Line 5954",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(9.066 36.09)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5955",
    "data-name": "Line 5955",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(17.933 30.935)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5956",
    "data-name": "Line 5956",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(26.8 25.779)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5957",
    "data-name": "Line 5957",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(35.667 20.623)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5958",
    "data-name": "Line 5958",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(44.534 15.467)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5959",
    "data-name": "Line 5959",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(53.401 10.311)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5960",
    "data-name": "Line 5960",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(62.268 5.156)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5961",
    "data-name": "Line 5961",
    className: "cls-19",
    y1: 48.602,
    transform: "translate(71.134)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5962",
    "data-name": "Line 5962",
    className: "cls-19",
    y1: 42.081,
    x2: 73.706,
    transform: "translate(0 40.398)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5963",
    "data-name": "Line 5963",
    className: "cls-19",
    y1: 42.081,
    x2: 73.706,
    transform: "translate(0 32.974)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5964",
    "data-name": "Line 5964",
    className: "cls-19",
    y1: 42.081,
    x2: 73.706,
    transform: "translate(0 25.55)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5965",
    "data-name": "Line 5965",
    className: "cls-19",
    y1: 42.081,
    x2: 73.706,
    transform: "translate(0 18.126)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5966",
    "data-name": "Line 5966",
    className: "cls-19",
    y1: 42.081,
    x2: 73.706,
    transform: "translate(0 10.702)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5967",
    "data-name": "Line 5967",
    className: "cls-19",
    y1: 42.081,
    x2: 73.706,
    transform: "translate(0 3.278)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69661",
    "data-name": "Path 69661",
    className: "cls-62",
    d: "M1363.4,997.993l9.715-22.406,9.717-2.141,1.812-6.094,3.788-7.247,5.6-1.977,4.777-4.941,1.153-8.071,5.6-6.753,6.588,4.118,4.243-4.443,5.506-3.2,2.6-7.181,10.071-2.065",
    transform: "translate(-1156.852 -785.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69662",
    "data-name": "Path 69662",
    className: "cls-63",
    d: "M1359.03,908.881s8.73-.659,9.224,0,3.624-3.294,3.624-3.294l6.918.824,7.742-12.449,8.565-7.843,14.166-4.086.824-11.2,7.412-8.4V853.7l12.783-17.016",
    transform: "translate(-1153.142 -709.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69663",
    "data-name": "Path 69663",
    className: "cls-64",
    d: "M1376.465,922.916l14.048-8.163a2.777,2.777,0,0,0,1.333-2.1v-.262c0-.733-.6-.987-1.333-.563l-14.048,8.163a2.778,2.778,0,0,0-1.334,2.1v.261c0,.734.6.987,1.334.563",
    transform: "translate(-1166.804 -773.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69664",
    "data-name": "Path 69664",
    className: "cls-22",
    d: "M1346,1427.287l12.21-7.1a2.414,2.414,0,0,0,1.16-1.829v-.227c0-.637-.522-.858-1.16-.49l-12.21,7.1a2.415,2.415,0,0,0-1.16,1.829v.227c0,.638.522.858,1.16.49",
    transform: "translate(-1141.1 -1202.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69665",
    "data-name": "Path 69665",
    className: "cls-22",
    d: "M1293.946,1124.219l6.1-3.548a1.208,1.208,0,0,0,.58-.914v-.114c0-.319-.261-.429-.58-.245l-6.1,3.548a1.208,1.208,0,0,0-.58.914v.114c0,.318.261.429.58.245",
    transform: "translate(-1097.426 -949.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69666",
    "data-name": "Path 69666",
    className: "cls-22",
    d: "M1293.946,1174.122l6.1-3.548a1.207,1.207,0,0,0,.58-.914v-.114c0-.319-.261-.429-.58-.245l-6.1,3.548a1.209,1.209,0,0,0-.58.915v.114c0,.319.261.428.58.245",
    transform: "translate(-1097.426 -992.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69667",
    "data-name": "Path 69667",
    className: "cls-22",
    d: "M1293.946,1224.024l6.1-3.548a1.208,1.208,0,0,0,.58-.915v-.114c0-.319-.261-.429-.58-.245l-6.1,3.548a1.208,1.208,0,0,0-.58.915v.114c0,.319.261.428.58.245",
    transform: "translate(-1097.426 -1034.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69668",
    "data-name": "Path 69668",
    className: "cls-22",
    d: "M1293.946,1273.924l6.1-3.548a1.209,1.209,0,0,0,.58-.914v-.114c0-.319-.261-.429-.58-.245l-6.1,3.548a1.209,1.209,0,0,0-.58.914v.114c0,.318.261.429.58.245",
    transform: "translate(-1097.426 -1076.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69669",
    "data-name": "Path 69669",
    className: "cls-22",
    d: "M1293.946,1323.827l6.1-3.548a1.208,1.208,0,0,0,.58-.915v-.113c0-.319-.261-.429-.58-.244l-6.1,3.548a1.208,1.208,0,0,0-.58.915v.113c0,.319.261.429.58.245",
    transform: "translate(-1097.426 -1119.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69670",
    "data-name": "Path 69670",
    className: "cls-22",
    d: "M1293.946,1373.727l6.1-3.548a1.207,1.207,0,0,0,.58-.915v-.113c0-.319-.261-.429-.58-.245l-6.1,3.548a1.206,1.206,0,0,0-.58.915v.113c0,.319.261.429.58.244",
    transform: "translate(-1097.426 -1161.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69671",
    "data-name": "Path 69671",
    className: "cls-22",
    d: "M1482.763,1347.328l12.21-7.1a2.415,2.415,0,0,0,1.159-1.829v-.227c0-.637-.522-.858-1.159-.49l-12.21,7.1a2.414,2.414,0,0,0-1.159,1.829v.227c0,.638.522.858,1.159.49",
    transform: "translate(-1257.146 -1134.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69672",
    "data-name": "Path 69672",
    className: "cls-22",
    d: "M1619.528,1267.37l12.21-7.095a2.415,2.415,0,0,0,1.16-1.829v-.227c0-.637-.522-.858-1.16-.489l-12.21,7.1a2.413,2.413,0,0,0-1.16,1.829v.227c0,.637.522.858,1.16.489",
    transform: "translate(-1373.191 -1067.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69673",
    "data-name": "Path 69673",
    className: "cls-22",
    d: "M1756.293,1187.412l12.21-7.095a2.415,2.415,0,0,0,1.159-1.829v-.227c0-.637-.521-.858-1.159-.489l-12.21,7.1a2.415,2.415,0,0,0-1.16,1.829v.227c0,.637.522.858,1.16.489",
    transform: "translate(-1489.237 -999.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69674",
    "data-name": "Path 69674",
    className: "cls-64",
    d: "M1376.465,930.116l26.588-15.364a2.778,2.778,0,0,0,1.334-2.1v-.261c0-.734-.6-.987-1.334-.563l-26.588,15.364a2.778,2.778,0,0,0-1.334,2.1v.261c0,.733.6.987,1.334.563",
    transform: "translate(-1166.804 -773.511)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiDashboard);
export default __webpack_public_path__ + "static/media/KPIDashboard.04b083dcf0f1292fa6f60c425b32982b.svg";
export { ForwardRef as ReactComponent };